export default "__VITE_ASSET__DzqE0FFJ__"